import React from 'react'
import PropTypes from 'prop-types'

const LabelWrapper = ({label, name, input}) => {
  return <div className='uk-margin'>
    <label className='uk-form-label label-align-right' htmlFor={name}>{label}</label>
    <div className='uk-form-controls'>
      {input}
    </div>
  </div>
}

LabelWrapper.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  input: PropTypes.node.isRequired
}

export default LabelWrapper
